import React, { useState } from 'react'
import {
  MenuFoldOutlined,
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
  HomeOutlined,
} from '@ant-design/icons'
import { Dropdown, Menu, Breadcrumb, Modal } from 'antd'
import './topbar.scss'
import userAvatar from './../../assets/user.png'
import { useDispatch, useSelector } from 'react-redux'
import { toggleSidebar } from '../../redux/userRedux'
import { useNavigate, useLocation } from 'react-router-dom'
import { handleLogout } from '../../utils/auth'
import NotificationBell from '../notifications/NotificationBell'

const ROUTE_LABELS = {
  '/': 'Accueil',
  '/client': 'Clients',
  '/clientRapport': 'Rapport Clients',
  '/client_form': 'Nouveau Client',
  '/clientEdit': 'Modifier Client',
  '/sites': 'Sites',
  '/traceurs': 'Traceurs',
  '/traceurRapport': 'Rapport Traceurs',
  '/traceurs_form': 'Nouveau Traceur',
  '/traceurEdit': 'Modifier Traceur',
  '/operations': 'Operations',
  '/operationRapport': 'Rapport Operations',
  '/operations_form': 'Nouvelle Operation',
  '/affectation': 'Affectations',
  '/affectation_form': 'Nouvelle Affectation',
  '/numero': 'Numeros',
  '/numero_form': 'Nouveau Numero',
  '/vehicules': 'Vehicules',
  '/vehiculeRapport': 'Rapport Vehicules',
  '/vehicule_form': 'Nouveau Vehicule',
  '/marques': 'Marques & Modèles',
  '/recharge': 'Recharges',
  '/recharge_form': 'Nouvelle Recharge',
  '/rechargeOne': 'Recharge',
  '/personnel': 'Personnel',
  '/personnel_form': 'Nouveau Personnel',
  '/personnel_edit': 'Modifier Personnel',
  '/paiement': 'Paiements',
  '/position': 'Position',
  '/signal': 'Signale',
  '/facturation': 'Facturation',
  '/factureEffectue': 'Factures Effectuees',
  '/facturation_form': 'Nouvelle Facture',
  '/rapport': 'Tableau de Bord',
  '/rapport_global': 'Rapport Global',
  '/rapport_client': 'Rapport Client',
  '/rapport_vehicule': 'Rapport Vehicule',
  '/rapport_finance': 'Rapport Finance',
  '/dette': 'Dettes',
  '/depense': 'Depenses',
  '/permissions': 'Permissions',
  '/permissionOne': 'Permission',
  '/parametres': 'Parametres',
  '/profile': 'Profil',
  '/presence': 'Pointage du jour',
  '/presence/dashboard': 'Tableau de bord RH',
  '/presence/calendrier': 'Calendrier',
  '/presence/jours_feries': 'Jours feries',
  '/presence/horaires': 'Horaires de travail',
  '/presence/salaire': 'Gestion salariale',
  '/presence/terminaux': 'Terminaux',
};

const PARENT_MAP = {
  '/client_form': '/client',
  '/clientEdit': '/client',
  '/clientRapport': '/client',
  '/traceurs_form': '/traceurs',
  '/traceurEdit': '/traceurs',
  '/traceurRapport': '/traceurs',
  '/operations_form': '/operations',
  '/operationRapport': '/operations',
  '/affectation_form': '/affectation',
  '/numero_form': '/numero',
  '/vehicule_form': '/vehicules',
  '/vehiculeRapport': '/vehicules',
  // M&M (Task 61) : /marque_form redirige vers /marques (page fusionnée)
  '/marque_form': '/marques',
  '/recharge_form': '/recharge',
  '/rechargeOne': '/recharge',
  '/personnel_form': '/personnel',
  '/personnel_edit': '/personnel',
  '/facturation_form': '/facturation',
  '/factureEffectue': '/facturation',
  '/rapport_global': '/rapport',
  '/rapport_client': '/rapport',
  '/rapport_vehicule': '/rapport',
  '/rapport_finance': '/rapport',
  '/permissionOne': '/permissions',
  '/sites': '/client',
  '/presence/dashboard': '/presence',
  '/presence/calendrier': '/presence',
  '/presence/jours_feries': '/presence',
  '/presence/horaires': '/presence',
  '/presence/salaire': '/presence',
  '/presence/terminaux': '/presence',
};

const Topbar = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user.currentUser.username);
  const role = useSelector((state) => state.user.currentUser.role);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const buildBreadcrumbs = () => {
    const path = location.pathname;
    const items = [{ title: <><HomeOutlined /> Accueil</>, path: '/' }];

    const exactMatch = ROUTE_LABELS[path];
    if (exactMatch && path !== '/') {
      const parentPath = PARENT_MAP[path];
      if (parentPath && ROUTE_LABELS[parentPath]) {
        items.push({ title: ROUTE_LABELS[parentPath], path: parentPath });
      }
      items.push({ title: exactMatch, path: null });
    }

    return items;
  };

  const breadcrumbs = buildBreadcrumbs();

  const handleMenuClick = ({ key }) => {
    if (key === 'logout') {
      Logout()
    } else if (key === 'profile') {
      navigate('/profile');
    } else if (key === 'settings') {
      navigate('/parametres');
    }
    setDropdownVisible(false)
  }

    const Logout = () => {
      Modal.confirm({
        title: 'Déconnexion',
        content: 'Êtes-vous sûr de vouloir vous déconnecter ?',
        okText: 'Oui, me déconnecter',
        cancelText: 'Annuler',
        okButtonProps: { danger: true },
        onOk: () => handleLogout(navigate),
      });
    };

  const menu = (
    <Menu onClick={handleMenuClick} className="topbar-dropdown-menu">
      <Menu.Item key="profile" icon={<UserOutlined />}>
        Mon profil
      </Menu.Item>
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        Parametres
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} danger>
        Deconnexion
      </Menu.Item>
    </Menu>
  )

  return (
    <header className="topbar">
      <div className="topbar__container">
        <div className="topbar__left">
          <button
            className="topbar__menu-btn"
            onClick={() => dispatch(toggleSidebar())}
            aria-label="Toggle sidebar"
          >
            <MenuFoldOutlined />
          </button>
          {breadcrumbs.length > 1 && (
            <Breadcrumb
              className="topbar__breadcrumb"
              items={breadcrumbs.map((b, i) => ({
                key: i,
                title: b.path
                  ? <a onClick={(e) => { e.preventDefault(); navigate(b.path); }}>{b.title}</a>
                  : <span>{b.title}</span>,
              }))}
            />
          )}
        </div>

        <div className="topbar__right">
          <div className="topbar__actions">
            <NotificationBell />
          </div>

          <Dropdown
            overlay={menu}
            trigger={['click']}
            open={dropdownVisible}
          >
            <div className="topbar__user">
              <img src={userAvatar} alt="User" />
              <div className="topbar__user-info">
                <span className="name">{user}</span>
                <span className="role">{role || 'Utilisateur'}</span>
              </div>
            </div>
          </Dropdown>
        </div>
      </div>
    </header>
  )
}

export default Topbar
